import React, { Component } from 'react';
import { getOr, set, omit, isEmpty, values, debounce, isNil } from 'lodash/fp';
import PropTypes from 'prop-types';
import { Panel, SelectPicker, DateRangePicker, Button } from 'rsuite';
import {
  LabelByStatus,
  Status,
  Context
} from '../../constants/download-request';

const DownloadRequestContexts = values(Context);

const defaultQueryState = {
  status: null,
  userId: null,
  createdAt: [],
  completedAt: []
};

const statusOptions = [
  { value: Status.IN_PROGRESS, label: LabelByStatus[Status.IN_PROGRESS] },
  { value: Status.COMPLETE, label: LabelByStatus[Status.COMPLETE] }
];

class DownloadRequestSearch extends Component {
  debounceSubmit = debounce(1000)(query => {
    const { onSubmit } = this.props;
    onSubmit(query);
  });

  constructor(props) {
    super(props);
    this.state = defaultQueryState;
  }

  static getDerivedStateFromProps({ searchQuery }) {
    return { ...defaultQueryState, ...searchQuery };
  }

  componentDidMount() {
    const { onInit, context } = this.props;
    onInit(context);
  }

  onQueryChange = (key, val) => {
    this.setState({ [key]: val });
    const { onChange, queryOptions } = this.props;
    const newQuery =
      val || !isNil(val)
        ? set(key, val, queryOptions)
        : omit(key, queryOptions);
    onChange(newQuery);
    this.debounceSubmit(newQuery);
  };

  handleUserChange = userId => {
    this.onQueryChange('userId', userId);
  };

  handleCreatedAtChange = createdAt => {
    this.onQueryChange('createdAt', createdAt);
  };

  handleCompletedAtChange = createdAt => {
    this.onQueryChange('createdAt', createdAt);
  };

  handleStatusChange = status => {
    this.onQueryChange('status', status);
  };

  handleSubmit = () => {
    const { onSubmit, queryOptions } = this.props;
    onSubmit(queryOptions);
  };

  handleReset = () => {
    const { onReset, context } = this.props;
    this.setState(defaultQueryState);
    onReset(context);
  };

  render() {
    const { searchQuery, queryOptions, userOptions, isFetching } = this.props;
    return (
      <Panel bordered style={{ marginBottom: 20 }}>
        <SelectPicker
          style={{ width: 150, marginRight: 10 }}
          value={getOr('', 'userId', queryOptions)}
          data={userOptions}
          appearance="default"
          placeholder="User"
          onChange={this.handleUserChange}
          disabled={isFetching}
        />
        <DateRangePicker
          style={{ width: 230, marginRight: 10 }}
          value={getOr([], 'createdAt', queryOptions)}
          placeholder="Date Created"
          onChange={this.handleCreatedAtChange}
          disabled={isFetching}
        />
        <DateRangePicker
          style={{ width: 230, marginRight: 10 }}
          value={getOr([], 'completedAt', queryOptions)}
          placeholder="Date Completed"
          onChange={this.handleCompletedAtChange}
          disabled={isFetching}
        />
        <SelectPicker
          style={{ width: 150, marginRight: 10 }}
          value={getOr(null, 'status', queryOptions)}
          data={statusOptions}
          appearance="default"
          placeholder="Status"
          onChange={this.handleStatusChange}
          disabled={isFetching}
        />
        <Button
          style={{ float: 'right' }}
          disabled={isFetching || isEmpty(searchQuery)}
          onClick={this.handleReset}
          appearance="ghost"
        >
          Clear
        </Button>
      </Panel>
    );
  }
}

const OptionType = PropTypes.shape({
  value: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired
});

DownloadRequestSearch.propTypes = {
  context: PropTypes.oneOf(DownloadRequestContexts).isRequired,
  searchQuery: PropTypes.shape({
    context: PropTypes.oneOf(DownloadRequestContexts)
  }).isRequired,
  queryOptions: PropTypes.shape({
    context: PropTypes.oneOf(DownloadRequestContexts)
  }).isRequired,
  onInit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  userOptions: PropTypes.arrayOf(OptionType).isRequired
};

export default DownloadRequestSearch;
